// Generated with util/create-component.js
import Head from './Head';

export default Head;
